var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 11.9941C20.0293 14.2834 20.6697 16.5233 21.855 18.4821C21.9468 18.6337 21.9967 18.8071 21.9995 18.9843C22.0023 19.1616 21.9579 19.3364 21.8709 19.4909C21.7839 19.6453 21.6574 19.7739 21.5044 19.8634C21.3513 19.9528 21.1773 20 21 20.0001H2.99999C2.82271 20 2.64863 19.9528 2.4956 19.8634C2.34256 19.7739 2.21607 19.6453 2.12907 19.4909C2.04207 19.3364 1.99769 19.1616 2.00049 18.9843C2.00329 18.8071 2.05316 18.6337 2.14499 18.4821C3.33125 16.5215 3.9717 14.2794 3.99999 11.9881V8.0061C3.99999 5.88437 4.84284 3.84954 6.34313 2.34925C7.84342 0.848958 9.87825 0.00610352 12 0.00610352C14.1217 0.00610352 16.1565 0.848958 17.6568 2.34925C19.1571 3.84954 20 5.88437 20 8.0061V11.9941ZM14.1213 23.1205C13.8067 23.4351 13.4261 23.6758 13.007 23.8251C12.6358 23.9574 12.2423 24.0152 11.8488 23.9954C11.4554 23.9755 11.0696 23.8784 10.7137 23.7095C10.3578 23.5406 10.0386 23.3032 9.77442 23.0109C9.51022 22.7187 9.30619 22.3772 9.17395 22.0061H14.826C14.6766 22.4252 14.4359 22.8059 14.1213 23.1205Z",
    fill: "#101010"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.7244b3bb7e978f257c3fad65b4c4d62a.svg";
export { ForwardRef as ReactComponent };